import { REACT_APP_LANGUAGE_CHANGE_ENABLE } from "../config/environment";

export const configurations = {
    configFeatureFlags: {
        ASSORTMENT: 'assortment-tool-feature-flag',
        MANAGEMENT_DATA: 'management-data-flag',
        OPS: 'ops-tool-feature-flag',
        PROMOTIONS: 'promotions-tool-feature-flag',
        PUSH_NOTIFICATIONS: 'pushnotifications-tool-feature-flag',
        isLanguageChangeEnabled: REACT_APP_LANGUAGE_CHANGE_ENABLE || 'false'
    },
}
